enum ENewsletter {
  uploadNewsletter = 'newsletter/subscribe',
}

export default ENewsletter;
